export enum MailingMethods {
  Manual = "Manual",
  Automated = "Automated",
  CSV = "CSV",
}